var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crash" },
    [
      _c("div", { staticClass: "crash-game" }, [
        _c(
          "div",
          { staticClass: "crash-scene" },
          [
            _c("crash-home-game", {
              attrs: { gameState: _vm.gameState.status },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "crash-game-ui" },
          [
            !_vm.$screen.mobile
              ? _c(
                  "div",
                  { staticClass: "crash-sidebar" },
                  [
                    _c("ui-game-sidebar", {
                      ref: "sidebar",
                      attrs: {
                        gameState: _vm.gameState,
                        tick: _vm.tick,
                        ownBet: _vm.ownBet,
                        publicSeed: _vm.publicSeed,
                        privateHash: _vm.privateHash,
                        gameCountDownData: _vm.gameCountDownData,
                        enterAmount: _vm.enterAmount,
                      },
                      on: { handleStart: _vm.clickBet, handleEnd: _vm.cashout },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c("CrashGame", {
              attrs: {
                tick: _vm.tick,
                gameState: _vm.gameState.status,
                gameCountDownData: _vm.gameCountDownData,
                crashPoint: _vm.crashPoint,
                allBetAmount: _vm.allBetAmount,
                playersCount: _vm.playersCount,
                spectateTarget: _vm.spectateTarget,
                crashOutPlayers: _vm.crashOutPlayers,
                mvpList: _vm.mvpList,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "crash-game__history" },
          [
            _c("div", { staticClass: "crash-home-history" }, [
              _c(
                "div",
                { staticClass: "history__games" },
                [
                  _c(
                    "HorizontalScroll",
                    { staticClass: "my-scroll-area" },
                    [
                      _vm._l(_vm.history, function (item, index) {
                        return [
                          _c(
                            "router-link",
                            {
                              staticClass: "history__game link",
                              class: _vm.historyGameColor(
                                "history__game",
                                item.crashPoint
                              ),
                              attrs: {
                                to: {
                                  name: _vm.crashHistoryDetailRouteName,
                                  params: { id: item.id },
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "multiplier" }, [
                                _vm._v(_vm._s(item.crashPoint) + "x"),
                              ]),
                            ]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
            _c(
              "router-link",
              {
                staticClass: "btn btn_grey btn_history",
                attrs: { to: { name: _vm.crashHistoryRouteName } },
              },
              [
                _c("span", { staticClass: "icon icon_file-list-alt" }),
                _c("span", { staticClass: "btn__text" }, [_vm._v("历史")]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm.$screen.mobile
        ? _c("ui-game-sidebar", {
            ref: "sidebar",
            attrs: {
              gameState: _vm.gameState,
              tick: _vm.tick,
              ownBet: _vm.ownBet,
              publicSeed: _vm.publicSeed,
              privateHash: _vm.privateHash,
              gameCountDownData: _vm.gameCountDownData,
              enterAmount: _vm.enterAmount,
            },
            on: { handleStart: _vm.clickBet, handleEnd: _vm.cashout },
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "crash-game__content",
          attrs: { "data-tour": "bet-history" },
        },
        [
          _vm.players.length > 0
            ? [
                !_vm.isLoading
                  ? [
                      _c("VirtualScroller", {
                        attrs: {
                          items: _vm.sortedBets,
                          "min-item-width": "50%",
                          "max-rows": 10,
                          gap: 12,
                          "key-field": "userId",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c("crash-bet", {
                                    staticClass: "crash-bet",
                                    attrs: {
                                      bet: item,
                                      isOwner: item.userId == _vm.user.id,
                                      "is-lg": true,
                                    },
                                    on: { spectate: _vm.handleSpectate },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1027296883
                        ),
                      }),
                    ]
                  : [
                      _c(
                        "div",
                        { staticClass: "crash-game__scroll" },
                        _vm._l(5, function (item, index) {
                          return _c("skeletonRect", {
                            key: index,
                            staticClass: "skeleton-item",
                            attrs: { background: "rgba(25, 33, 72, 1)" },
                          })
                        }),
                        1
                      ),
                    ],
              ]
            : _c("div", { staticClass: "empty-state-box" }, [
                _c("i", { staticClass: "icon icon_file-list-alt empty-icon" }),
                _vm._m(0),
              ]),
        ],
        2
      ),
      _vm.$screen.mobile
        ? _c("div", { staticClass: "crash-game__footer" }, [
            _c("div", {
              staticClass: "crash-game__shield icon icon_shield-bold",
            }),
            _c("div", { staticClass: "crash-game__round" }, [
              _c("div", { staticClass: "crash-game__round-title" }, [
                _vm._v("防作弊哈希号"),
              ]),
              _c("div", { staticClass: "crash-game__round-number" }, [
                _vm._v(
                  " #" +
                    _vm._s(_vm.publicSeed && _vm.publicSeed.substring(0, 10)) +
                    " "
                ),
              ]),
            ]),
            _c("div", { staticClass: "crash-game__hash" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.privateHash && _vm.truncateString(_vm.privateHash, 10)
                  ) +
                  " "
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn_icon btn_copy",
                  on: { click: _vm.copyText },
                },
                [_c("span", { staticClass: "icon icon_copy-bold-alt" })]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-text-wrapper" }, [
      _c("span", { staticClass: "title-text" }, [_vm._v(" 暂无参与记录 ")]),
      _c("span", { staticClass: "sub-text" }, [_vm._v(" 快来参与吧 ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }